import { render, staticRenderFns } from "./PlanMovil.vue?vue&type=template&id=bfc47614&scoped=true&"
import script from "./PlanMovil.vue?vue&type=script&lang=js&"
export * from "./PlanMovil.vue?vue&type=script&lang=js&"
import style0 from "./PlanMovil.vue?vue&type=style&index=0&id=bfc47614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc47614",
  null
  
)

export default component.exports